// extracted by mini-css-extract-plugin
export default {"backIcon":"AdminMobileProductRegister_backIcon__AFdIO","regiBtn":"AdminMobileProductRegister_regiBtn__O0Cbv"};